/**
 * api/consumerPosts.js — Consumer Posts CRUD
 *
 * GET    /api/consumer-posts
 * POST   /api/consumer-posts
 * PUT    /api/consumer-posts/:id
 * DELETE /api/consumer-posts/:id
 */

import client from './client';

export const consumerPostsApi = {

  async getAll(params = {}) {
    const { data } = await client.get('/consumer-posts', { params });
    return data.data ?? data;
  },

  async create(payload) {
    const { data } = await client.post('/consumer-posts', payload);
    return data.data ?? data;
  },

  async update(id, payload) {
    const { data } = await client.put(`/consumer-posts/${id}`, payload);
    return data.data ?? data;
  },

  async remove(id) {
    await client.delete(`/consumer-posts/${id}`);
  },
};
